import { getCountries, getCountryCallingCode } from "react-phone-number-input";

/**
 * The phone prefix picker (#250). Its box always shows a code - the picker's defaultCountry, US
 * (+1), until another country is picked - but digits can also be typed straight into it, so "+1"
 * becomes "+199", a code no country has.
 */

/** What the picker shows until another country is chosen. */
export const DEFAULT_CALLING_CODE = "1";

const CALLING_CODES = new Set(getCountries().map((country) => getCountryCallingCode(country)));

/**
 * The code the field stands for: the one picked, or the default it shows when nothing was picked.
 *
 * @param {string | number | null | undefined} code "+44", "44" or 44; empty when nothing was picked.
 * @returns {string} The digits, e.g. "44".
 */
export const effectiveCallingCode = (code) =>
  String(code ?? "").replace(/^\+/, "") || DEFAULT_CALLING_CODE;

/** True when the field's code belongs to a country. */
export const isCountryCallingCode = (code) => CALLING_CODES.has(effectiveCallingCode(code));

export const COUNTRY_CODE_ERROR = "Please select a country code.";
